import { useEffect, useState } from "react"
import { fnRenderSmsPreview, fnRenderWhatsAppPreview } from "./render-utils"
import { AnniversaryOccasion, getOccasionDisplayName, WhatsAppTemplate } from "./types"
import { BibleVerse } from "../bible-verse/types"
import { calculateAge, calculateYearsSince } from "./util"

export function getBodyParameters(occassion: AnniversaryOccasion, verses: BibleVerse[]) {

    let occVerse: Partial<BibleVerse> = verses.find(v => v.category == occassion.type && v.language == "en") as Partial<BibleVerse>

    if (!occVerse) {
        occVerse = {
            verse_text: "Love is patient, love is kind. It does not envy, it does not boast, it is not proud.",
            reference: "1 Corinthians 13:4-7"
        }
    }

    return ({
        db_user_name: occassion.user.name,
        db_user_fname: `${occassion.user.gender === "male" ? "Brother" : occassion.user.gender === "female" ? "Sister" : "Mr.Mrs"} ${occassion.user.name}`,
        db_spouse_name: "spouse",
        db_spouse_fname: `${occassion.user.gender === "male" ? "Brother" : "Sister"} ${"spouse"}`,
        db_user_relation: "Spouse",
        db_user_anniv_year: `${calculateYearsSince(occassion.date)}`,
        sys_rand_verse: occassion.selectedVerse?.verse_text || occVerse.verse_text as string,
        sys_rand_verse_ref: occassion.selectedVerse?.reference || occVerse.reference as string,
        db_user_anniversary: `${calculateYearsSince(occassion.date)}`
    })
}

export function getHeaderParameters(occassion: AnniversaryOccasion, verses: BibleVerse[]) {
    // alert(occassion.selectedVerse?.verse_text)
    return getBodyParameters(occassion, verses)
}

export const AnniversaryTemplatePreview = ({ occassion, selectedOccasions,
    selectedIndex,
    handleNextPreview,
    handlePreviousPreview,whatsappTemplates,
    onClose, verses, handleChangeTemplate }: {
        occassion: AnniversaryOccasion,
        handlePreviousPreview: () => void,
        handleNextPreview: () => void
        onClose: () => void,
        selectedIndex: number,
        selectedOccasions: AnniversaryOccasion[],
        verses: BibleVerse[],
        whatsappTemplates: WhatsAppTemplate[],
        handleChangeTemplate: (template: WhatsAppTemplate) => void
    }) => {

    // const [whatsappTemplates, setWhatsappTemplates] = useState<WhatsAppTemplate[]>([])

    const [selectedTemplate, setSelectedTemplate] =
        useState<WhatsAppTemplate | null>(occassion.selectedWhatsappTemplate || null);

    useEffect(() => { setSelectedTemplate(occassion.selectedWhatsappTemplate || null) }, [occassion])
    const handleTemplateChange = (templateId: string) => {
        const template = whatsappTemplates.find((t) => t.id === templateId);
        // setSelectedTemplate(template || null);
        // occassion.selectedWhatsappTemplate = template
        if (template) {
            handleChangeTemplate(template)
            setSelectedTemplate(template);
        }
    };
/*
    const apiFetchWhatsappTemplates = () => {

        const token = localStorage.getItem("token")
        fetch("/api/messages/whatsapp-templates", { headers: { Authorization: `Bearer ${token}` } }).then(d => {
            d.json().then((d) => {

                let filteredTemplates = (d.data || []).filter((d: any) => d.name.match(RegExp(`anniversary_${occassion.type}`)))

                if (filteredTemplates.length == 0)
                    filteredTemplates = (d.data || []).filter((d: any) => d.name.match(RegExp(`anniversary_generic`)))

                setWhatsappTemplates(filteredTemplates)
                if (filteredTemplates.length > 0 && !selectedTemplate)
                    setSelectedTemplate(filteredTemplates[0])
            })
        })

    }
*/
    useEffect(() => {
        // apiFetchWhatsappTemplates()
        let filteredTemplates = whatsappTemplates.filter((d: any) => d.name.match(RegExp(`anniversary_${occassion.type}`)))

        if (filteredTemplates.length == 0)
            filteredTemplates = whatsappTemplates.filter((d: any) => d.name.match(RegExp(`anniversary_generic`)))

        // setWhatsappTemplates(filteredTemplates)
        if (filteredTemplates.length > 0 && !selectedTemplate)
            setSelectedTemplate(filteredTemplates[0])
    }, [occassion])

    useEffect(() => {
        // apiFetchWhatsappTemplates()
    }, [occassion])

    const templateHeaderParameters = getHeaderParameters(occassion, verses)
    const templateBodyParameters = getBodyParameters(occassion, verses)

    const renderWhatsAppPreview = fnRenderWhatsAppPreview(occassion.selectedWhatsappTemplate || selectedTemplate, templateHeaderParameters, templateBodyParameters);
    const renderSmsPreview = fnRenderSmsPreview(selectedTemplate, templateBodyParameters);

    return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white dark:bg-neutral-800 rounded-xl shadow-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto">
            <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold">Message Preview</h2>
                    <button
                        onClick={() => onClose()}
                        className="text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-200"
                    >
                        ✕
                    </button>
                </div>
                <div className="mb-4 p-4 bg-gray-50 dark:bg-neutral-700 rounded-lg">
                    <div className="flex items-center space-x-3 mb-3">
                        <img
                            src={occassion.user.avatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${occassion.user.avatar}`}
                            alt={occassion.user.name}
                            className="w-10 h-10 rounded-full"
                        />
                        <div>
                            <h3 className="font-semibold">{occassion.user.name}</h3>
                            <p className="text-sm text-neutral-600 dark:text-neutral-400">
                                {getOccasionDisplayName(occassion.type)} • {occassion.years} years
                            </p>
                        </div>

                    </div>
                    <div>
                        <select
                            value={selectedTemplate?.id || ''}
                            onChange={(e) => handleTemplateChange(e.target.value)}
                            className="w-full px-3 py-2 border border-neutral-300 dark:border-neutral-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-neutral-700 dark:text-white"
                        >
                            <option value="">Select a template</option>
                            {whatsappTemplates.map((template) => (
                                <option key={template.id} value={template.id}>
                                    {template.name} ({template.category}) - {template.parameter_format} - {template.status}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        {occassion.user.is_whatsapp_enabled && renderWhatsAppPreview()}
                    </div>
                    <div>
                        {!occassion.user.is_whatsapp_enabled && renderSmsPreview()}
                    </div>
                </div>

                {selectedOccasions.length > 1 && (
                    <div className="flex justify-between items-center">
                        <button
                            onClick={handlePreviousPreview}
                            className="px-4 py-2 bg-gray-100 dark:bg-neutral-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-200 dark:hover:bg-neutral-600 transition-colors"
                        >
                            Previous
                        </button>
                        <span className="text-sm text-neutral-600 dark:text-neutral-400">
                            {selectedIndex + 1} of {selectedOccasions.length}
                        </span>
                        <button
                            onClick={handleNextPreview}
                            className="px-4 py-2 bg-gray-100 dark:bg-neutral-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-200 dark:hover:bg-neutral-600 transition-colors"
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    </div>
}